module.exports = __webpack_public_path__ + "static/media/page1_bg.9c180cd7.png";